const handleRowColumnBtn = (e, index, chart, tabletoolContainer) => {
  if (chart.series[index].visible && chart.series[index].type === 'column') {
    e.currentTarget.classList.remove('active')
    tabletoolContainer.getElementsByClassName("text")[index].style.borderBlockColor = 'transparent'
    chart.series[index].update({
      visible: false,
      showInLegend: false
    })
  } else if (chart.series[index].visible && chart.series[index].type === 'line') {
    e.currentTarget.classList.add('active')
    // console.log(tabletoolContainer.getElementsByClassName("btn-line"))
    tabletoolContainer.getElementsByClassName("btn-line")[index].classList.remove('active')
    tabletoolContainer.getElementsByClassName("text")[index].style.borderBlockColor = chart.series[index].color
    chart.series[index].update({
      type: 'column',
    })
  } else if (!chart.series[index].visible) {
    e.currentTarget.classList.add('active')
    tabletoolContainer.getElementsByClassName("text")[index].style.borderBlockColor = chart.series[index].color
    chart.series[index].update({
      visible: true,
      showInLegend: true,
      type: 'column',
    })
  }
}

export default handleRowColumnBtn;
